import React from "react";

export default function MinusIconSvg(Props) {
  return Props.type === 2 ? (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="5.5" stroke="#98A2B3" />
      <path
        stroke="#98A2B3"
        strokeWidth="1.4"
        d="M5.0835 8H10.9168"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_453_7166)">
        <rect x="2" y="1" width="36" height="36" rx="8" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          rx="7.5"
          width="35"
          height="35"
          stroke="#EAECF0"
        />
        <g clip-path="url(#clip0_453_7166)">
          <path
            stroke="#D0D5DD"
            stroke-width="1.67"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.6666 19.0003H23.3333M28.3333 19.0003C28.3333 23.6027 24.6023 27.3337 20 27.3337C15.3976 27.3337 11.6666 23.6027 11.6666 19.0003C11.6666 14.398 15.3976 10.667 20 10.667C24.6023 10.667 28.3333 14.398 28.3333 19.0003Z"
          />
        </g>
      </g>
      <defs>
        <filter
          x="0"
          y="0"
          width="40"
          height="40"
          id="filter0_d_453_7166"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            type="matrix"
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_453_7166"
          />
          <feBlend
            mode="normal"
            result="shape"
            in="SourceGraphic"
            in2="effect1_dropShadow_453_7166"
          />
        </filter>
        <clipPath id="clip0_453_7166">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(10 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
